import { useCallback } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { useParams } from 'react-router-dom';
import { decode } from '../../../../../helpers/utils';
import { removePath } from '../../../../../store/slices/navigationSlice';
import { saveNavigationPaths } from './navigationService';
import { useProjectHeader } from '../../../../../pages/buildProject/Helpers/pageDiv/ProjectHeaderContext';

export const useDeletePinPaths = () => {
    const dispatch  = useDispatch();
    const store     = useStore();
    const { id }    = useParams();
    const decodedId = decode(id);
    const { handleEnableDisable } = useProjectHeader();
 
    const deletePinPaths = useCallback((pinEncId, floorId = null) => {
        if (!pinEncId) return;

        const currentPaths = store.getState().navigation.paths;

        const affected = currentPaths.filter((p) => {
            const pinMatch   = p.points?.some((pt) => String(pt.pinId) === String(pinEncId));
            const floorMatch = floorId == null || String(p.floorId) === String(floorId);
            return pinMatch && floorMatch;
        });

        if (affected.length === 0) return;
 
        const affectedFloorIds = [
            ...new Set(affected.map((p) => p.floorId).filter(Boolean)),
        ];
 
        affected.forEach((p) => dispatch(removePath(p.id)));
 
        const updatedPaths = store.getState().navigation.paths;
 
        affectedFloorIds.forEach((floorId) => {
            const floorPaths = updatedPaths.filter((p) => String(p.floorId) === String(floorId));
            saveNavigationPaths(decodedId, floorId, floorPaths)
                .then(() => handleEnableDisable())
                .catch((err) =>
                    console.error('Failed to save nav paths after pin delete:', err)
                );
        });
    }, [dispatch, store, decodedId]);

    return { deletePinPaths };
};
